<script setup>
</script>
<template>
    
    <h1 class="text-4xl font-bold text-blue-500 mb-4">Exibir modal criar fichamento.</h1>    
    
</template>